/**
 * 线上环境
 */
export const ONLINEHOST = 'http://demo.rccp.emof.cn/index.php'
    // export const ONLINEHOST = 'http://yx2.admin.zexian.org.cn'


/**
 * 测试环境
 */
// export const QAHOST = 'https://bgadmin.cxhzfw.org.cn'
    // export const QAHOST = 'http://yx2.admin.zexian.org.cn'
    // export const QAHOST = 'http://demo0886.emof.net'
    export const QAHOST = 'http://demo.rccp.emof.cn/index.php'



/**
 * 上传文件
 */
export const UPFILE = process.env.NODE_ENV === 'production' ? ONLINEHOST : QAHOST

/*
 * 图片展示
 * */
export const IMGURL = process.env.NODE_ENV === 'production' ? ONLINEHOST : QAHOST
export const FILEURL = process.env.NODE_ENV === 'production' ? ONLINEHOST : QAHOST


/*
 * 缓存字段
 * */
export const localAnStore = [{
    key: 'user',
    type: 'localStorage'
}, {
    key: 'token1',
    type: 'localStorage'
}, {
    key: 'token2',
    type: 'localStorage'
}, ]
